(() => {
  const init = (root) => {
    if (!root || root.dataset.dbpReady === 'true') return;
    root.dataset.dbpReady = 'true';

    const options = [...root.querySelectorAll('[data-color-option]')];
    const gallery = root.querySelector('[data-gallery]');
    const counter = root.querySelector('[data-gallery-counter]');
    const nav = root.querySelector('[data-gallery-nav]');
    const prevBtn = root.querySelector('[data-gallery-prev]');
    const nextBtn = root.querySelector('[data-gallery-next]');
    const swipeHint = root.querySelector('[data-swipe-hint]');
    const form = root.querySelector('.dbp__form');
    const variantInput = root.querySelector('[data-variant-input]');
    const colorwayInput = root.querySelector('[data-colorway-input]');
    const cta = root.querySelector('.dbp__cta');
    const group = root.querySelector('.dbp__options');
    const sticky = root.querySelector('[data-sticky-bar]');
    const lightbox = root.querySelector('[data-lightbox]');
    const lightboxImage = root.querySelector('[data-lightbox-image]');
    let pointerStartX = 0;
    let pointerStartY = 0;

    const parseGallery = (option) => {
      const raw = (option && (option.dataset.gallery || option.dataset.image)) || '';
      return raw.split('|||').map((url) => url.trim()).filter(Boolean);
    };

    const currentIndex = () => {
      if (!gallery || !gallery.clientWidth) return 0;
      return Math.max(0, Math.round(gallery.scrollLeft / gallery.clientWidth));
    };

    const setActiveSlide = () => {
      const total = slideCount();
      const index = currentIndex();
      if (counter) {
        counter.hidden = total < 2;
        counter.textContent = `${Math.min(index + 1, Math.max(total, 1))} / ${total || 1}`;
      }
    };

    const slideCount = () => (gallery ? gallery.querySelectorAll('[data-slide]').length : 0);

    const goToSlide = (index) => {
      if (!gallery) return;
      const total = slideCount();
      if (!total) return;
      const next = ((index % total) + total) % total;
      gallery.scrollTo({ left: next * gallery.clientWidth, behavior: 'smooth' });
    };

    const openLightbox = (src, alt) => {
      if (!lightbox || !lightboxImage || !src) return;
      lightboxImage.src = src;
      lightboxImage.alt = alt || 'Product image';
      if (typeof lightbox.showModal === 'function') lightbox.showModal();
    };

    const bindGallery = () => {
      if (!gallery) return;
      gallery.querySelectorAll('[data-slide]').forEach((slide) => {
        slide.addEventListener('pointerdown', (event) => {
          pointerStartX = event.clientX;
          pointerStartY = event.clientY;
        });
        slide.addEventListener('click', (event) => {
          if (Math.abs(event.clientX - pointerStartX) > 12 || Math.abs(event.clientY - pointerStartY) > 12) return;
          const img = slide.querySelector('img');
          const rect = slide.getBoundingClientRect();
          const x = event.clientX - rect.left;
          const desktop = window.matchMedia('(min-width: 768px)').matches;
          if (desktop && slideCount() > 1) {
            if (x < rect.width * 0.22) {
              goToSlide(currentIndex() - 1);
              return;
            }
            if (x > rect.width * 0.78) {
              goToSlide(currentIndex() + 1);
              return;
            }
          }
          if (img && img.src) openLightbox(img.src, img.alt);
        });
      });
    };

    const renderGallery = (urls, altBase) => {
      if (!gallery) return;
      const list = urls.length ? urls : [];
      gallery.innerHTML = list.map((url, index) => {
        const alt = `${altBase || 'Airflow Rope Hat'}${index ? ` ${index + 1}` : ''}`;
        return `<figure class="dbp__slide" data-slide><img class="dbp__hero-image" src="${url}" alt="${alt.replace(/"/g, '')}" width="1600" height="1600" ${index === 0 ? 'loading="eager"' : 'loading="lazy"'}></figure>`;
      }).join('');
      gallery.scrollLeft = 0;
      if (nav) nav.hidden = list.length < 2;
      if (swipeHint) swipeHint.hidden = list.length < 2;
      bindGallery();
      setActiveSlide();
    };

    if (gallery) {
      gallery.addEventListener('scroll', () => setActiveSlide(), { passive: true });
      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goToSlide(currentIndex() + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goToSlide(currentIndex() - 1);
        }
      });
        bindGallery();
        setActiveSlide();
    }

    prevBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goToSlide(currentIndex() - 1);
    });
    nextBtn?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      goToSlide(currentIndex() + 1);
    });

    root.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });

    const selectOption = (option, scroll) => {
      if (!option) return;

      options.forEach((item) => {
        const selected = item === option;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-checked', selected ? 'true' : 'false');
        item.tabIndex = selected ? 0 : -1;
      });

      const data = option.dataset;
      const available = data.available !== 'false';
      root.style.setProperty('--dbp-tone', data.tone || '#e7dcc8');

      const captionName = root.querySelector('[data-caption-name]');
      const captionNote = root.querySelector('[data-caption-note]');
      const colorName = root.querySelector('[data-color-name]');
      const colorNote = root.querySelector('[data-color-note]');
      const price = root.querySelector('[data-price]');
      const compare = root.querySelector('[data-compare-price]');
      const ctaLabel = root.querySelector('[data-cta-label]');
      const stickyName = root.querySelector('[data-sticky-name]');

      if (captionName) captionName.textContent = (data.name || '').toUpperCase();
      if (captionNote) captionNote.textContent = (data.note || '').toUpperCase();
      if (colorName) colorName.textContent = data.name || '';
      if (colorNote) colorNote.textContent = data.note || '';
      if (price) price.textContent = data.price || '';
      if (compare) {
        compare.textContent = data.comparePrice || '';
        compare.hidden = !data.comparePrice;
      }
      if (variantInput && data.variantId) variantInput.value = data.variantId;
      if (colorwayInput) colorwayInput.value = data.name || '';
      if (ctaLabel) ctaLabel.textContent = available ? `Preorder for ${data.price || ''}`.trim() : 'Sold out';
      root.querySelectorAll('[data-cta-price], [data-sticky-price]').forEach((el) => {
        el.textContent = data.price || '';
      });
      if (stickyName) stickyName.textContent = (data.name || '').toUpperCase();
      if (cta) cta.disabled = !available || !data.variantId;

      renderGallery(parseGallery(option), `${data.name || ''} Airflow Rope Hat`.trim());

      if (data.variantId && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', data.variantId);
        window.history.replaceState({}, '', url);
      }

      if (scroll) root.querySelector('.dbp__hero')?.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      if (group && window.matchMedia('(max-width: 767px)').matches) {
        const groupRect = group.getBoundingClientRect();
        const optionRect = option.getBoundingClientRect();
        const delta = optionRect.left - groupRect.left - (groupRect.width - optionRect.width) / 2;
        group.scrollTo({ left: Math.max(0, group.scrollLeft + delta), behavior: 'smooth' });
        window.scrollTo({ left: 0 });
      }
    };

    options.forEach((option) => {
      option.addEventListener('click', () => selectOption(option, false));
    });

    if (group) {
      group.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
        if (!keys.includes(event.key)) return;
        event.preventDefault();
        const current = options.findIndex((item) => item.classList.contains('is-selected'));
        let next = current < 0 ? 0 : current;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % options.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + options.length) % options.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = options.length - 1;
        options[next].focus();
        selectOption(options[next], false);
      });
    }

    root.querySelectorAll('[data-lineup-option]').forEach((button) => {
      button.addEventListener('click', () => {
        selectOption(options.find((option) => option.dataset.name === button.dataset.lineupOption), true);
      });
    });

    const stickySubmit = root.querySelector('[data-sticky-submit]');
    if (stickySubmit && form) {
      stickySubmit.addEventListener('click', () => {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    let seenSelector = false;
    let selectorVisible = false;
    let ctaVisible = true;
    const cartIsOpen = () => {
      const cart = document.querySelector('.rebuy-cart');
      if (!cart) return false;
      const className = `${document.body.className} ${document.documentElement.className} ${cart.className}`;
      if (/(^|\s)(rebuy-cart-visible|rebuy-cart--open|is-visible)(\s|$)/.test(className)) return true;
      const flyout = cart.querySelector('.rebuy-cart__flyout');
      if (!flyout) return false;
      const style = window.getComputedStyle(flyout);
      const rect = flyout.getBoundingClientRect();
      return style.visibility !== 'hidden' && style.display !== 'none' && rect.left < window.innerWidth && rect.width > 80;
    };
    const updateSticky = () => {
      if (!sticky) return;
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      const show = mobile && seenSelector && !selectorVisible && !ctaVisible && !cartIsOpen();
      sticky.hidden = !show;
      sticky.classList.toggle('is-visible', show);
      document.body.classList.toggle('is-dbp-sticky-visible', show);
    };
    if ('IntersectionObserver' in window) {
      if (group) {
        const selectorObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            selectorVisible = entry.isIntersecting;
            if (entry.isIntersecting || entry.boundingClientRect.bottom < 0) {
              seenSelector = true;
            }
          });
          updateSticky();
        }, { threshold: [0, 0.1, 0.25, 1], rootMargin: '0px' });
        selectorObserver.observe(group);
      }
      if (cta) {
        const ctaObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            ctaVisible = entry.isIntersecting;
          });
          updateSticky();
        }, { threshold: 0.15, rootMargin: '0px 0px 72px 0px' });
        ctaObserver.observe(cta);
      }
    }
    ['rebuy:cart.show', 'rebuy:cart.hide', 'rebuy:smartcart.show', 'rebuy:smartcart.hide'].forEach((name) => {
      document.addEventListener(name, updateSticky);
    });
    window.addEventListener('resize', updateSticky, { passive: true });
    updateSticky();

    const hidePromoConflicts = () => {
      document.querySelectorAll('.klaviyo-form, .klaviyo-close-form, [class*="kl-teaser-"]').forEach((el) => {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.setAttribute('aria-hidden', 'true');
        let node = el.parentElement;
        for (let i = 0; i < 8 && node && node !== document.body; i += 1) {
          const style = window.getComputedStyle(node);
          if (style.position === 'fixed') {
            const rect = node.getBoundingClientRect();
            if (rect.width > 40 && rect.height > 20) {
              node.style.setProperty('display', 'none', 'important');
              node.setAttribute('aria-hidden', 'true');
            }
            break;
          }
          node = node.parentElement;
        }
      });
    };
    hidePromoConflicts();
    const promoObserver = new MutationObserver(hidePromoConflicts);
    promoObserver.observe(document.documentElement, { childList: true, subtree: true });

    const productForm = root.querySelector('product-form');
    if (productForm) {
      productForm.addEventListener('add-to-cart', () => {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
        }
      });
    }

    const dialog = root.querySelector('[data-terms-dialog]');
    root.querySelector('[data-terms-open]')?.addEventListener('click', () => dialog?.showModal());
    root.querySelector('[data-terms-close]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    root.querySelectorAll('.dbp__faq details').forEach((item) => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('.dbp__faq details').forEach((other) => {
          if (other !== item) other.open = false;
        });
      });
    });

    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (variantId) {
      const match = options.find((option) => option.dataset.variantId === variantId);
      if (match) selectOption(match, false);
    }
  };

  const initAll = () => {
    document.querySelectorAll('[data-dbp-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-dbp-root]');
    if (root) {
      root.dataset.dbpReady = 'false';
      init(root);
    }
  });
})();
